import { render } from "./ChangeLastName.vue.js?vue&type=template&id=04324622!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeLastName.vue?vue&type=template&id=04324622"
import script from "./ChangeLastName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeLastName.vue?vue&type=script&lang=js"
export * from "./ChangeLastName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeLastName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/ChangeLastName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04324622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04324622', __exports__)) {
    api.reload('04324622', __exports__)
  }
  
  module.hot.accept("./ChangeLastName.vue.js?vue&type=template&id=04324622!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ChangeLastName.vue?vue&type=template&id=04324622", () => {
    api.rerender('04324622', render)
  })

}


export default __exports__